import React from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIconBase from './SvgIconBase.tsx';

import HomeDefaultClientProfileSetupSrc from '../../svgs/newicons/home-default-client-profile-setup.svg';
import HomeDefaultPortfolioManagementSrc from '../../svgs/newicons/home-default-portfolio-management.svg';
import HomeDefaultRebateWorkflowSrc from '../../svgs/newicons/home-default-rebate-workflow.svg';
import HomeDefaultUserAdministrationSrc from '../../svgs/newicons/home-default-user-administration-1.svg';
import HomeHoverClientProfileSetupSrc from '../../svgs/newicons/home-hover-client-profile-setup.svg';
import HomeHoverPortfolioManagementSrc from '../../svgs/newicons/home-hover-portfolio-management.svg';
import HomeHoverRebateWorkflowSrc from '../../svgs/newicons/home-hover-rebate-workflow.svg';
import HomeHoverUserAdministrationSrc from '../../svgs/newicons/home-hover-user-administration-1.svg';
import LandingClientProfileSetupSrc from '../../svgs/newicons/landing-client-Profile-setup.svg';
import LandingPortfolioManagementSrc from '../../svgs/newicons/landing-portfolio-management.svg';
import LandingRebateWorkflowSrc from '../../svgs/newicons/landing-rebate-workflow.svg';
import LandingUserAdministrationSrc from '../../svgs/newicons/landing-user-administration-1.svg';
import LandingMyDashboardBlackSrc from '../../svgs/newicons/landing_mydashboard_black_on_transparant.svg';
import LandingMyDashboardWhiteSrc from '../../svgs/newicons/my-dashboard 1.svg';


export const HomeDefaultClientProfileSetupIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeDefaultClientProfileSetupSrc} {...props} />
);

export const HomeDefaultPortfolioManagementIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeDefaultPortfolioManagementSrc} {...props} />
);

export const HomeDefaultRebateWorkflowIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeDefaultRebateWorkflowSrc} {...props} />
);

export const HomeDefaultUserAdministrationIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeDefaultUserAdministrationSrc} {...props} />
);

export const HomeHoverClientProfileSetupIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeHoverClientProfileSetupSrc} {...props} />
);

export const HomeHoverPortfolioManagementIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeHoverPortfolioManagementSrc} {...props} />
);

export const HomeHoverRebateWorkflowIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeHoverRebateWorkflowSrc} {...props} />
);

export const HomeHoverUserAdministrationIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={HomeHoverUserAdministrationSrc} {...props} />
);

export const LandingClientProfileSetupIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={LandingClientProfileSetupSrc} {...props} />
);

export const LandingMyDashboardWhiteIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={LandingMyDashboardWhiteSrc} {...props} />
);

export const LandingPortfolioManagementIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={LandingPortfolioManagementSrc} {...props} />
);

export const LandingRebateWorkflowIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={LandingRebateWorkflowSrc} {...props} />
);

export const LandingUserAdministrationIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={LandingUserAdministrationSrc} {...props} />
);

export const LandingMyDashboardBlackIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase src={LandingMyDashboardBlackSrc} {...props} />
);